
<template>
  <div v-if="value">
    <el-dialog
      :title="title"
      :visible="value"
      :close-on-click-dialog="false"
      @close="close"
      :width="dialogWidth"
      center
      class="ele-dialog"
    >
      <slot name="dialog-body" >
        <component :is="component" :extra="extra" ref="mt-add"  v-on="$listeners"></component>
      </slot>
      <!-- <div slot="footer" class="dialog-footer">
        <slot name="dialog-footer">
          <el-button type="primary" v-if="showConfirm" @click="confirmBtn"
            >确 定</el-button
          >
          <el-button @click="closeBtn">取 消</el-button>
        </slot>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MtWindow',
  props: {
       // 组件地址及其名称
    extra: {
      type: Object||Array,
    },
    path: {
      type: String,
      default: true
    },
    //是否隐藏确认按钮
    // showConfirm: {
    //   type: Boolean,
    //   default: true
    // },
    // 显示与隐藏，绑定到v-model上的值
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    // 宽度
    width: {
      type: String,
      default: '60%'
    },
    // 标题
    title: {
      type: String,
      default: '新增',
      required: false
    },
    // 关闭的事件回调
    callback: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      dialogWidth: this.width
    }
  },
  created() {
    this.setDialogWidth()
    this.registerComponent(this.path)
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  methods: {
      registerComponent(templateName) {
        this.component = resolve => require([`@/views/${templateName}.vue`], resolve)
    },
    // cartBottomStatus(val){
    //   this.$emit('cartBottomStatus',val)
    // },
    // 关闭窗口的事件
    close() {
      this.$emit('input', false)
    },
    // 关闭按钮事件
    closeBtn() {
      if (this.callback) {
        this.callback()
      } else {
        this.close()
      }
    },
    // 确认按钮事件
    // confirmBtn() {
    //   this.$emit('confirmBtn')
    // },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 1024 // 默认宽度
      if (val <= def) {
        this.dialogWidth = '80%'
      }
    }
  }
}
</script>
<style scoped>
.dialog-footer {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Mt/MtWindow/index.vue